<template>
  <yn-modal>
    <span slot="title">What is wrong here?</span>
    <div slot="footer">
      <yn-button type="text" color="secondary" @click="cancel">Cancel</yn-button>
      <yn-button type="contained" color="primary" :disabled="!isValid" @click="submit">Complain</yn-button>
    </div>
    <form @submit="submit">
      <div>
        <yn-multiselect
          v-model="selectedOption"
          label="Complaint"
          :taggable="false"
          :searchable="false"
          placeholder=""
          :options="['Irrelevant', 'Too short', 'Not Safe For Work', 'Offensive']"
        />
      </div>
      <div>
        <yn-text-field v-model="complaint" label=" " :multiline="true" :rows="10" />
      </div>
    </form>
  </yn-modal>
</template>

<script>
import TextField from './../common/TextField';
import Button from './../common/Button';
import Multiselect from './../common/Multiselect';
import Modal from './../common/Modal';

export default {
  components: {
    'yn-text-field': TextField,
    'yn-button': Button,
    'yn-modal': Modal,
    'yn-multiselect': Multiselect
  },
  data() {
    return {
      selectedOption: 'Irrelevant',
      complaint: 'Task is irrelevant or not well-formed.'
    };
  },
  computed: {
    isValid() {
      return this.complaint && this.complaint.length && this.complaint.length < 256;
    }
  },
  watch: {
    selectedOption() {
      switch (this.selectedOption) {
        case 'Too short':
          this.complaint = 'Context of this question is way too short to come up with any kind of answer.';
          break;
        case 'Not Safe For Work':
          this.complaint = 'Question contains Not Safe For Work type of content. Please consider removing it.';
          break;
        case 'Offensive':
          this.complaint =
            'Question contains content with offensive or abusive language, discriminating or oppressive statements.';
          break;
        default:
          this.complaint = 'Context of this question is totally irrelevant or is composed of gibberish characters.';
          break;
      }
    }
  },

  methods: {
    submit() {
      if (!this.isValid) {
        return;
      }
      this.$emit('submit', { complaint: this.complaint });
    },
    cancel() {
      this.$emit('close');
    }
  }
};
</script>
